module.exports = __webpack_public_path__ + "img/jy85-xcb-icon-1@2x.3571ecdb.png";